export { default as ar } from './ar.json';
export { default as bg } from './bg.json';
export { default as bs } from './bs.json';
export { default as cs } from './cs.json';
export { default as da } from './da.json';
export { default as de } from './de.json';
export { default as el } from './el.json';
export { default as enAU } from './en-AU.json';
export { default as enCA } from './en-CA.json';
export { default as enGB } from './en-GB.json';
export { default as enIN } from './en-IN.json';
export { default as enUS } from './en-US.json';
export { default as en } from './en.json';
export { default as es419 } from './es-419.json';
export { default as esES } from './es-ES.json';
export { default as es } from './es.json';
export { default as et } from './et.json';
export { default as fi } from './fi.json';
export { default as frCA } from './fr-CA.json';
export { default as frFR } from './fr-FR.json';
export { default as fr } from './fr.json';
export { default as he } from './he.json';
export { default as hr } from './hr.json';
export { default as hu } from './hu.json';
export { default as id } from './id.json';
export { default as is } from './is.json';
export { default as it } from './it.json';
export { default as ja } from './ja.json';
export { default as ko } from './ko.json';
export { default as lt } from './lt.json';
export { default as lv } from './lv.json';
export { default as mk } from './mk.json';
export { default as ms } from './ms.json';
export { default as nl } from './nl.json';
export { default as no } from './no.json';
export { default as pl } from './pl.json';
export { default as ptBR } from './pt-BR.json';
export { default as pt } from './pt.json';
export { default as ro } from './ro.json';
export { default as ru } from './ru.json';
export { default as sl } from './sl.json';
export { default as sk } from './sk.json';
export { default as sr } from './sr.json';
export { default as sv } from './sv.json';
export { default as th } from './th.json';
export { default as tr } from './tr.json';
export { default as uk } from './uk.json';
export { default as vi } from './vi.json';
export { default as zhCN } from './zh-CN.json';
export { default as zhHK } from './zh-HK.json';
export { default as zhTW } from './zh-TW.json';
